import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const StatusSkeleton = () => {
    return (
        <div className="flex items-center justify-between">
            <div className="w-1/3 flex flex-col gap-5">
                <p>
                    <Skeleton height={20} />
                </p>
                <p>
                    <Skeleton height={20} />
                </p>
                <p>
                    <Skeleton height={20} />
                </p>
            </div>
            <div className="w-1/3 mr-8 max-[1200px]:w-1/2">
                <Skeleton
                    width={172}
                    height={172}
                    style={{ borderRadius: "50%" }}
                />
            </div>
        </div>
    );
};

export default StatusSkeleton;
